<div class="map-buttons-container">
  <tc-profiles-list
    class="map-button"
    *ngIf="connectSettings"
    [step]="step"
    [attributesMetadata]="attributesMetadata"
    [connectSettings]="connectSettings"
  ></tc-profiles-list>

  <tc-report-list
    class="map-button"
    *ngIf="connectSettings"
    [connectSettings]="connectSettings"
  ></tc-report-list>
</div>
